import { render, staticRenderFns } from "./orderCard.vue?vue&type=template&id=e786d176&"
import script from "./orderCard.vue?vue&type=script&lang=js&"
export * from "./orderCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports